import React from 'react';
import {
  Typography,
  Box,
  useTheme,
} from '@mui/material';
import { PageLayout } from '../../components/footer/PageLayout';
import { ContentSection } from '../../components/footer/ContentSection';

export const TermsPage: React.FC = () => {
  const theme = useTheme();

  return (
    <PageLayout
      title="Terms of Service"
      subtitle="Please read these terms of service carefully before using our platform."
    >
      <ContentSection>
        <Box sx={{ maxWidth: '800px', mx: 'auto' }}>
          <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2 }}>
            1. Acceptance of Terms
          </Typography>
          <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.6 }}>
            By accessing and using the Careva platform, you accept and agree to be bound by the terms and provision of this agreement.
          </Typography>

          <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2 }}>
            2. Use License
          </Typography>
          <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.6 }}>
            Permission is granted to temporarily download one copy of the materials on Careva's website for personal, non-commercial transitory viewing only.
          </Typography>

          <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2 }}>
            3. Disclaimer
          </Typography>
          <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.6 }}>
            The materials on Careva's website are provided on an 'as is' basis. Careva makes no warranties, expressed or implied, and hereby disclaims and negates all other warranties including without limitation, implied warranties or conditions of merchantability, fitness for a particular purpose, or non-infringement of intellectual property or other violation of rights.
          </Typography>

          <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2 }}>
            4. Limitations
          </Typography>
          <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.6 }}>
            In no event shall Careva or its suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use the materials on Careva's website, even if Careva or a Careva authorized representative has been notified orally or in writing of the possibility of such damage.
          </Typography>

          <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2 }}>
            5. Accuracy of Materials
          </Typography>
          <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.6 }}>
            The materials appearing on Careva's website could include technical, typographical, or photographic errors. Careva does not warrant that any of the materials on its website are accurate, complete, or current.
          </Typography>

          <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2 }}>
            6. Links
          </Typography>
          <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.6 }}>
            Careva has not reviewed all of the sites linked to our website and is not responsible for the contents of any such linked site. The inclusion of any link does not imply endorsement by Careva of the site.
          </Typography>

          <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2 }}>
            7. Modifications
          </Typography>
          <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.6 }}>
            Careva may revise these terms of service for its website at any time without notice. By using this website you are agreeing to be bound by the then current version of these terms of service.
          </Typography>

          <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2 }}>
            8. Governing Law
          </Typography>
          <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.6 }}>
            These terms and conditions are governed by and construed in accordance with the laws of the United States and you irrevocably submit to the exclusive jurisdiction of the courts in that state or location.
          </Typography>
        </Box>
      </ContentSection>
    </PageLayout>
  );
};
